import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { IdmsSharedService } from 'src/app/Modules/idms/services/idms-shared.service';
import { InstanceSettings } from 'src/app/Modules/management/models/instance/instace-setting.model';
import { ManagementApiService, UserUtilityService } from 'src/app/services';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';

@Component({
    selector: 'app-bar-code-qr-code',
    templateUrl: './bar-code-qr-code.component.html',
    styleUrls: ['./bar-code-qr-code.component.scss'],
})
export class BarCodeQrCodeComponent implements OnInit {
    @Input() idmsFormGroup;

    barcodeFormGroup;
    iDMsarea: InstanceSettings[];
    barcodeSelected: string;
    stateOptions = [
        { label: 'Barcode', value: '' },
        { label: 'none', value: '' },
    ];

    stateOptions2 = [
        { label: 'QR code', value: '' },
        { label: 'none', value: '' },
    ];
    stateOptions3 = [
        { label: 'Barcode', value: '' },
        { label: 'none', value: 'none' },
    ];
    barcodeKeys = ['ReportBarcode_Visible', 'ReportQRCode_Visible', 'TagBarcode_Visible'];

    constructor(
        private managementApiService: ManagementApiService,
        private userUtilityService: UserUtilityService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private globalEmiiterService: GlobalEmittersService,
        private customToastService: CustomToastService,
        private IdmsSharedService: IdmsSharedService
    ) {}

    async ngOnInit() {
        this.getBarcodeAndBuildForm();

        this.globalEmiiterService.barcodeSaveEvent.subscribe((resp) => {
            if (resp) {
                let resultpayload: any = [];

                Object.keys(this.idmsFormGroup.get('barcodeFormGroup').controls).forEach((key) => {
                    const control = this.idmsFormGroup.get('barcodeFormGroup').get(key);

                    if (control.dirty) {
                        let payloadObj: any = {};
                        let barcodeItem = this.iDMsarea.find((x) => x.setting.key == key);
                        payloadObj.instanceId = localStorage.getItem('currentInstanceId');
                        payloadObj.settingId = barcodeItem.setting.settingId;
                        payloadObj.settingValueId = control.value;
                        payloadObj.instanceSettingId = barcodeItem.instanceSettingId;
                        resultpayload.push(payloadObj);
                    }
                });

                if (resultpayload.length > 0) {
                    this.ngxUiLoaderService.start();

                    this.managementApiService.updateInstanceSettings(resultpayload).subscribe(
                        async (resp) => {
                            if (resp.success) {
                                // This block runs regardless of the outcome (success or error)
                                this.ngxUiLoaderService.stop();
                                const formArray = this.idmsFormGroup as FormGroup;
                                formArray.removeControl('barcodeFormGroup');
                                await this.getBarcodeAndBuildForm();
                                this.customToastService.successToast('Barcode settings updated successfully!', 'Success');
                            } else {
                                this.ngxUiLoaderService.stop();
                                this.userUtilityService.errorModelPopup(resp.message);
                            }
                        },
                        (err) => {
                            this.ngxUiLoaderService.stop();
                            this.userUtilityService.errorModelPopup(err);
                        }
                    );
                }
            }
        });
    }

    async getBarcodeAndBuildForm() {
        try {
            this.ngxUiLoaderService.start();
            let areaIdResp = await this.managementApiService.getSettingProfileAreaId('iDMS').toPromise();
            if (areaIdResp.success) {
                if (areaIdResp.response.settingAreaId) {
                    let settingdata = await this.managementApiService
                        .getInstanceSettings(areaIdResp.response.settingAreaId, localStorage.getItem('currentInstanceId'))
                        .toPromise();
                    if (settingdata.success) {
                        this.iDMsarea = settingdata.response;
                        let resp = this.idmsFormGroup as FormGroup; // assuming idmsFormGroup is a FormGroup, not a FormArray

                        this.barcodeFormGroup = new FormGroup({});

                        const updateStateOptions = (match: any, stateOptions: any[], label: string) => {
                            if (match) {
                                stateOptions.forEach((x) => {
                                    const trueSettingValueId = match.setting.settingValues.find((y) => y.value.toLowerCase() === 'true')?.settingValueId;
                                    const falseSettingValueId = match.setting.settingValues.find((y) => y.value.toLowerCase() === 'false')?.settingValueId;

                                    if (x.label.toLowerCase() === label) {
                                        x.value = trueSettingValueId;
                                    } else {
                                        x.value = falseSettingValueId;
                                    }
                                });
                            }
                        };

                        this.barcodeKeys.forEach((key) => {
                            const match = settingdata.response.find((item) => item.setting.key === key);
                            if (match) {
                                const control = new FormControl(match?.settingValue?.settingValueId);
                                this.barcodeFormGroup.addControl(key, control);
                            }

                            if (match && match.setting.key == 'ReportBarcode_Visible') {
                                updateStateOptions(match, this.stateOptions, 'barcode');
                            }

                            if (match && match.setting.key == 'ReportQRCode_Visible') {
                                updateStateOptions(match, this.stateOptions2, 'qr code');
                            }

                            if (match && match.setting.key == 'TagBarcode_Visible') {
                                updateStateOptions(match, this.stateOptions3, 'barcode');
                            }
                        });

                        // Assuming idmsFormGroup is a FormGroup and you want to add barcodeFormGroup as a nested form group
                        resp.addControl('barcodeFormGroup', this.barcodeFormGroup);
                        this.ngxUiLoaderService.stop();
                    } else {
                        this.ngxUiLoaderService.stop();
                        this.userUtilityService.errorModelPopup(settingdata.message);
                    }
                }
            } else {
                this.ngxUiLoaderService.stop();
            }
        } catch (err) {
            this.userUtilityService.errorModelPopup(err.message);
        }
    }
}
